'use client'
import React from 'react'

import BottomSheet from '@/shared/components/BottomSheet'
import { Text } from '@/shared/components/typography'

type PurchaseNoticeProps = {
  isOpen: boolean
  onClick: () => void
  onClose: () => void
}

const SharedTimeNotice = ({ isOpen, onClick, onClose }: PurchaseNoticeProps) => {
  const imgSrc = {
    src: '/images/light_img_paymentnotice_emptyspot.png',
    alt: '주차 중 이동 지양 안내 이미지',
    width: 130,
    height: 80
  }
  const bodyContent = (
    <div className="flex w-full flex-col px-2">
      <div className="mb-8 mt-6">
        <Text level="text3" color="text090">
          이용 시간 중 자리를 비울 경우 부정 주차가
          <br />
          발생해 다시 주차하기 어려울 수 있습니다. 이용
          <br /> 하지 못한 시간에 대한 부분 환불은 불가하므로,
          <br />
          <span className="text-caution-070">이용 시간 도중 차량을 이동하지 않는 것</span>을 권장합니다.
        </Text>
      </div>
    </div>
  )
  return (
    <BottomSheet
      imgSrc={imgSrc}
      isOpen={isOpen}
      className="body-1 h-[56px]"
      pyValue="py-0"
      title="주차 중 이동을 지양해주세요"
      bodyContent={bodyContent}
      btnText="닫기"
      onClick={onClick}
    />
  )
}

export default SharedTimeNotice
